'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var BlockAsset = require('@narvar/nth-block-asset');
var DynamicHeader = require('@narvar/nth-bundle-dynamic-header');
var NarvarFooter = require('@narvar/nth-bundle-narvar-footer');
var NthFeature_module = require('./NthFeature.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);
var BlockAsset__default = /*#__PURE__*/_interopDefaultLegacy(BlockAsset);
var DynamicHeader__default = /*#__PURE__*/_interopDefaultLegacy(DynamicHeader);
var NarvarFooter__default = /*#__PURE__*/_interopDefaultLegacy(NarvarFooter);

const NthFeature = _ref => {
  var _node$options, _node$options$customF, _node$options2;
  let {
    node,
    sticky
  } = _ref;
  const footerClasses = clsx__default["default"]({
    [NthFeature_module["default"].footerPadding]: true,
    [NthFeature_module["default"].footerSticky]: sticky
  });
  switch (node.name) {
    case 'Block Asset':
      return /*#__PURE__*/React__default["default"].createElement(BlockAsset__default["default"], {
        featureName: node.id ? `assets.${node.id}` : 'assets',
        featureId: node.id ?? '' ?? ((_node$options = node.options) === null || _node$options === void 0 ? void 0 : (_node$options$customF = _node$options.customFeature) === null || _node$options$customF === void 0 ? void 0 : _node$options$customF.settings),
        fixedPanelHeight: ((_node$options2 = node.options) === null || _node$options2 === void 0 ? void 0 : _node$options2.fixedPanelHeight) ?? undefined
      });
    case 'Dynamic Header':
      return /*#__PURE__*/React__default["default"].createElement(DynamicHeader__default["default"], {
        featureName: "narvarHeader"
      });
    case 'Help Pill':
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
    case 'Narvar Footer':
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: footerClasses
      }, /*#__PURE__*/React__default["default"].createElement(NarvarFooter__default["default"], {
        featureName: "narvarFooter"
      }));
    default:
      throw new Error(`Unsupported feature: ${node.name}`);
  }
};

exports["default"] = NthFeature;
